import { Radio } from "lucide-react";
import { useData } from "@/context/DataContext";
import { resolveUrl } from "@/lib/api";

export const LiveBanner = () => {
  const { settings } = useData();
  if (!settings?.live_mode) return null;
  const links = settings.live_links || [];
  return (
    <div data-testid="live-banner" className="relative z-40 bg-red-600 text-white">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-2.5 flex flex-wrap items-center gap-x-5 gap-y-1.5 justify-center text-sm">
        <span className="inline-flex items-center gap-2 font-bold uppercase tracking-wide">
          <Radio className="w-4 h-4 pulse-dot" /> {settings.live_title || "LIVE – NOVEMBERKÅSAN 2026"}
        </span>
        {links.map((l, i) => (
          <a key={i} href={resolveUrl(l.url)} target="_blank" rel="noreferrer" className="font-mono text-xs uppercase tracking-widest underline underline-offset-4 hover:text-black transition-colors">
            {l.label}
          </a>
        ))}
      </div>
    </div>
  );
};
